import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Paper, Typography } from '@mui/material'
import FormikControl from '../../molecules/FormikControl'
import { Card } from '@mui/material'
import { Link } from 'react-router-dom'
import makeStyles from '@mui/styles/makeStyles'
import logoRTG from '../../../images/logo_rtg_black.svg'
import { handleOpenAlert } from '../../../lib/handleAlert'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import LoadingButton from '@mui/lab/LoadingButton'

const useStyles = makeStyles((theme) => ({
  nested: {
    padding: theme.spacing(10),
  },
  listItem: {
    color: theme.palette.white.main,
  },
  logo: {
    filter:
      'invert(18%) sepia(44%) saturate(1598%) hue-rotate(182deg) brightness(98%) contrast(84%);',
    maxWidth: '500px',
    width: '450px',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },

  error: {
    color: theme.palette.error.main,
  },

  paperBack: {
    background: theme.palette.primary.light,
    position: 'absolute',
    minHeight: '450px',
    minWidth: '510px',
    margin: '0px 0px 50px 55px',
    maxWidth: '600px',
    maxHeight: '490px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  paperFront: {
    position: 'relative',
    maxWidth: '540px',
    maxHeight: '450px',
    width: '100',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  formBg: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '24px',
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  form: {
    height: '100%',
    width: '100%',
    maxWidth: '600px',
    maxHeight: '490px',
    display: 'flex',
    gap: '18px',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      maxWidth: 'unset',
    },
  },
  btn: {
    background: theme.palette.primary.main,
  },
}))

const PasswordResetCode = () => {
  const classes = useStyles()
  const { code } = useParams()
  const history = useHistory()

  const [validCode, setValidCode] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (code) {
      checkCode(code)
    }
  }, [code])

  const checkCode = (code) => {
    axios
      .post(
        '/api/doctor/auth/password/reset/check',
        { token: code },
        { headers: { ignoreAlerts: true } }
      )
      .then(() => {
        setValidCode(true)
        setLoaded(true)
      })
      .catch(() => {
        handleOpenAlert({
          title: 'Uwaga!',
          subtitle: 'Link nie jest aktualny',
          type: 'error',
        })
        history.push('/login')
      })
  }

  return (
    <>
      <Formik
        initialValues={{ password: '', passwordConfirmation: '' }}
        validationSchema={Yup.object({
          password: Yup.string()
            .min(8, 'Hasło musi mieć co najmniej 8 znaków')
            .required('Pole wymagane'),
          passwordConfirmation: Yup.string()
            .min(8, 'Hasło musi mieć co najmniej 8 znaków')
            .oneOf(
              [Yup.ref('password'), null],
              'Hasło musi być takie samo w obu polach'
            )
            .required('Pole wymagane'),
        })}
        onSubmit={async (values) => {
          setLoading(true)
          axios
            .post('/api/doctor/auth/password/reset/change', {
              ...values,
              token: code,
            })
            .then(async (res) => {
              if (res.status == 200) {
                handleOpenAlert({
                  title: 'Sukces!',
                  subtitle: 'Twoje hasło zostało zmienione.',
                })
                setLoading(false)
                history.push('/login')
              }
            })
            .catch(() => {
              setLoading(false)
              history.push('/login')
            })
        }}
      >
        {(formik) => (
          <form className={classes.formBg} onSubmit={formik.handleSubmit}>
            <Paper className={classes.paperBack} elevation={3}></Paper>
            <Card className={classes.paperFront} sx={{ minWidth: 'unset' }}>
              <div className={classes.form}>
                <Link to="/login">
                  <img className={classes.logo} src={logoRTG} alt="logo" />
                </Link>
                <div className="gap-4 flex flex-wrap flex-col">
                  <h1 className="text-left text-custom_blue_dark text-2xl">
                    Reset hasła - Krok 2
                  </h1>
                  <Typography>Prosimy podać nowe hasło.</Typography>
                  <div className=" flex gap-4 flex-col justify-center w-9/12 mx-auto">
                    <FormikControl
                      variableName="password"
                      handleChange={formik.handleChange}
                      labelName="Nowe hasło"
                      formik={formik}
                      type="password"
                      inputProps={{
                        autoComplete: 'new-password',
                      }}
                    />
                    <FormikControl
                      variableName="passwordConfirmation"
                      handleChange={formik.handleChange}
                      labelName="Powtórz hasło"
                      formik={formik}
                      type="password"
                      inputProps={{
                        autoComplete: 'new-password',
                      }}
                    />
                  </div>
                </div>
                <div className=" flex justify-between items-center gap-8 flex-wrap sm:justify-center sm:gap-2">
                  <Typography className={classes.error}>
                    {loaded && !validCode && 'Link nie jest aktualny'}
                  </Typography>
                  <LoadingButton
                    className={classes.btn}
                    color="primary"
                    variant="contained"
                    disabled={!validCode || !loaded}
                    type="submit"
                    loading={loading}
                    size="large"
                  >
                    Prześlij
                  </LoadingButton>
                </div>
              </div>
            </Card>
          </form>
        )}
      </Formik>
    </>
  )
}

export default PasswordResetCode
